import {Directive, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Renderer2, Output} from '@angular/core';

@Directive({
  selector: '[ld-track-scroll]'
})
export class TrackScrollDirective implements OnInit, OnDestroy {
  @Input() scrolling: string;
  @Input() ancestorSelector: string;

  @Output() onScrolledToBottom = new EventEmitter<void>();

  private hostElement: ElementRef;
  private intervalCheck: any;
  private lastDiff: number;
  private lastHeight: number;
  private renderer: Renderer2;

  constructor(hostElement: ElementRef, renderer: Renderer2) {
    this.hostElement = hostElement;
    this.renderer = renderer;
}

  ngOnInit() {
    let element: any = this.hostElement.nativeElement;

    if (this.scrolling === 'ancestor') {

      if (this.ancestorSelector) {

        while (!element.querySelector(this.ancestorSelector)) {
          element = element.parentNode;
        }

        element = element.querySelector(this.ancestorSelector);
      } else {
        console.error('ld-track-scroll should specify an ancestorSelector if scrolling is set to "ancestor"');
      }
    } else if (this.scrolling) {
      element = element.querySelector(this.scrolling);
    }

    try {
      if (element) {
        this.renderer.listen(element, 'scroll', this.onScroll);
      } else {
        console.error('[track-scroll] element not found', this.scrolling);
      }
    } catch (err) {
      console.error('[track-scroll] can\'t match element for scrolling check:', this.scrolling, err);
    }

    this.intervalCheck = setInterval(() => {
      this.scrollMatch(element);
    }, 200);
  }

  ngOnDestroy(): void {
    try {
      clearInterval(this.intervalCheck);
    } catch (err) {
    }
  }

  onScroll = ($event: Event): void => {
    this.scrollMatch($event.target);
  }

  scrollMatch(element: any): void {
    if (this.lastHeight !== element.offsetHeight) {
      element.scrollTop = 0;
    }

    let diff: number = element.scrollHeight - element.scrollTop - element.offsetHeight;

    if (diff < 10 && element.offsetHeight && (this.lastDiff !== diff || this.lastHeight !== element.offsetHeight)) {
      this.onScrolledToBottom.emit();
    }

    this.lastDiff = diff;
    this.lastHeight = element.offsetHeight;
  }
}
